import React from "react";
import { IoIosArrowForward } from "react-icons/io";
import { RiArrowRightDoubleLine, RiStore2Line } from "react-icons/ri";
import { Button, Col, Row } from "reactstrap";
import styles from './ShippingAndDetails.module.scss';
import { PiMapPinAreaFill } from "react-icons/pi";
import ScrollToTop from "../../../components/common/ScrollToTop/ScrollToTop";

const ShippingAndDetails = ({ setActiveTab }) => {
  return (
    <div className={styles.mainShippingContainer}>
      <ScrollToTop />

      <div className={styles.shippingHeader}>
        <h4 className={styles.sectionHeading}>Shipping & Billing</h4>
        <div className={styles.btnConatiner}>
          <Button color="link" className={styles.addNewBtn}>Add new</Button>
          <Button color="link" className={styles.changeBtn}>Change</Button>
        </div>
      </div>

      <div className={styles.shippingLocationContainer}>
        <div>
          <PiMapPinAreaFill size={24} />
        </div>
        <div>
          <div className={styles.personName}>Ali Ahmed</div>
          <div>House # 20</div>
          <div>Punjab, Faisalabad, Al-Noor Garden </div>
          <div>03230220030</div>
        </div>
      </div>

      <div className={styles.productsHeader}>
        <h4 className={styles.sectionHeading}>Products</h4>
      </div>

      <div className={styles.productDetailContainer}>
        <Row noGutters className={styles.productDetailRow}>
          <Col xl={9}>
            <Row noGutters className={styles.cartProductRow}>
              <div className={styles.storeWrapper}>
                <span>
                  <RiStore2Line size={18} className={styles.storeIcon} />
                </span>
                <span className={styles.storeName}>AS Store</span>
                <span>
                  <IoIosArrowForward size={18} className={styles.storeArrow} />
                </span>
              </div>

              <Col xs={7} md={9}>
                <div className={styles.cartItemDetail}>
                  <div>
                    <img src="https://placehold.co/122x128?text=Maelano" alt="Product Image" />
                  </div>
                  <div className={styles.cartItemProductSpec}>
                    <div>
                      <p className={styles.productName}>Sports T-shirt for Men</p>
                      <p className={styles.productSpec}>Pink/S/Polyester</p>
                      <p className={styles.productQuantity}>Qty: 1</p>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={5} md={3}>
                <p className={styles.productPrice}>
                  $33.99
                </p>
              </Col>
            </Row>
          </Col>

          <Col xl={3}>
            <div className={styles.deliveryChargesContainer}>
              <div className="d-flex align-items-center justify-content-between">
                <span className="text-muted">Delivery Charges</span>
                <span style={{ color: "#ea7231" }}>$2.00</span>
              </div>
              <div style={{ display: "grid", gap: ".5rem" }}>
                <div className="border p-1 rounded-2" style={{ display: "flex" }}>
                  <div style={{ flex: 1 }}>
                    <div>Standard Delivery</div>
                    <div className="text-muted" style={{ fontSize: "0.938rem" }}>
                      5-7 business days
                    </div>
                  </div>
                  <div>
                    <IoIosArrowForward />
                  </div>
                </div>
                <div className="border p-1 rounded-2" style={{ display: "flex" }}>
                  <div style={{ flex: 1 }}>
                    <div>Standard Delivery</div>
                    <div className="text-muted" style={{ fontSize: "0.938rem" }}>
                      5-7 business days
                    </div>
                  </div>
                  <div>
                    <IoIosArrowForward />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className={styles.paymentBtnContainer}>
        <Button
          color="info"
          className={styles.paymentBtn}
          onClick={() => setActiveTab('2')}
        >
          Proceed to Payment Method
          <RiArrowRightDoubleLine size={28} className={styles.arrowIcon} />
        </Button>
      </div>
    </div>
  )
}

export default ShippingAndDetails;